import type { IconNode } from '../types';

/**
 * @name guitar-electric
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTIuMTcyIDExLjgyOCA0LjI0Mi00LjI0MiIgLz4KICA8cGF0aCBkPSJNMTYuNDE0IDcuNTg2QTIgMiAwIDAwMTcgNi4xNzJWNWEyIDIgMCAwMTEuMTc3LTEuODIzTDIwLjU5IDIuMDlhMSAxIDAgMDExLjMyIDEuMzJsLTEuMDg4IDIuNDEyQTIgMiAwIDAxMTkgN2gtMWEyIDIgMCAwMC0xLjU4Ni41ODYiIC8+CiAgPHBhdGggZD0ibTYgMTYgMiAyIiAvPgogIDxwYXRoIGQ9Ik04LjIzIDkuODVhMyAzIDAgMDExLjI4LTEuNDU0IDEgMSAwIDAxMS40OTYuODE1IDQgNCAwIDAwMy43ODMgMy43ODMgMSAxIDAgMDEuODE1IDEuNDk2IDMgMyAwIDAxLTEuNDU0IDEuMjhsLS45Mi4zOEEyIDIgMCAwMDEyIDE4YTQgNCAwIDAxLTQgNCA2IDYgMCAwMS02LTYgNCA0IDAgMDE0LTQgMiAyIDAgMDAxLjg1LTEuMjN6IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/guitar-electric
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const GuitarElectric: IconNode = [
  ['path', { d: 'm12.172 11.828 4.242-4.242' }],
  [
    'path',
    {
      d: 'M16.414 7.586A2 2 0 0017 6.172V5a2 2 0 011.177-1.823L20.59 2.09a1 1 0 011.32 1.32l-1.088 2.412A2 2 0 0119 7h-1a2 2 0 00-1.586.586',
    },
  ],
  ['path', { d: 'm6 16 2 2' }],
  [
    'path',
    {
      d: 'M8.23 9.85a3 3 0 011.28-1.454 1 1 0 011.496.815 4 4 0 003.783 3.783 1 1 0 01.815 1.496 3 3 0 01-1.454 1.28l-.92.38A2 2 0 0012 18a4 4 0 01-4 4 6 6 0 01-6-6 4 4 0 014-4 2 2 0 001.85-1.23z',
    },
  ],
];

export default GuitarElectric;
